import { StaleField } from 'components/shared/StaleField/StaleField.styles';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const PasswordField = styled(StaleField)`
  width: 240px;
  margin: 0 24px 0 0;
`;
